package com.kinoshazam.data.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AuthResult<T>(
    val result: T? = null,
    val message: String? = null,
)

@Serializable
sealed interface RegistrationResult {

    @Serializable
    @SerialName("Registered")
    data object Registered : RegistrationResult

    @Serializable
    @SerialName("UserExist")
    data object UserExist : RegistrationResult
}

@Serializable
sealed interface LoginResult {

    @Serializable
    @SerialName("Error")
    data class Error(val errorType: LoginError) : LoginResult

    @Serializable
    @SerialName("LoggedIn")
    data class LoggedIn(val refreshToken: String, val accessToken: String) : LoginResult

    @Serializable
    enum class LoginError {
        VERIFICATION_ERROR,
        CREDENTIAL_ERROR
    }
}

@Serializable
sealed interface VerifyEmailResult {

    @Serializable
    @SerialName("Success")
    data object Success : VerifyEmailResult

    @Serializable
    @SerialName("InvalidData")
    data object InvalidData : VerifyEmailResult
}

@Serializable
sealed interface VerifyOtpResult {

    @Serializable
    @SerialName("Success")
    data class Success(val verifyToken: String) : VerifyOtpResult

    @Serializable
    @SerialName("InvalidData")
    data object InvalidData : VerifyOtpResult
}
